
import { PRODUCT_PROVIDERS } from '@tracking'

import ProductThumb, { isLinkValid } from '../ProductThumb'

export default {
  components: {
    ProductThumb,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    wide: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    disabledSelfImpressionEvent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    provider() {
      return this.product.isRecommendation
        ? PRODUCT_PROVIDERS.EARLYBIRD
        : PRODUCT_PROVIDERS.ALGOLIA
    },

    listingId() {
      return this.product.listingId || this.product.id
    },

    shouldDisplayCard() {
      return isLinkValid(this.product.link, this.$navigation)
    },
  },
  methods: {
    propagateProductImpression(productTracking) {
      this.$emit('viewport-impression', productTracking)
    },
  },
}
